var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transactions-provider',{attrs:{"id":"CLTPFAILED","data-scope":("$client_" + (_vm.client.id) + "_failed"),"client-id":_vm.client.id,"transaction-types":_vm.transactionTypes,"statuses":_vm.statuses}},[_c('transactions-listing')],1)}
var staticRenderFns = []

export { render, staticRenderFns }